/* lib/App.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponentDev,
	add_location,
	attr_dev,
	create_component,
	destroy_component,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out,
	validate_slots
} from "svelte/internal";

import { setContext, createEventDispatcher } from "svelte";
import { getClient } from "./client";
import { assignValueToTarget } from "./targets";
import PostcodeLookup from "./PostcodeLookup";
const file = "lib/App.svelte";

function create_fragment(ctx) {
	let div;
	let div_class_value;
	let current;

	const postcodelookup = new PostcodeLookup({
			props: { getClient: /*func*/ ctx[7] },
			$$inline: true
		});

	postcodelookup.$on("address", /*handleAddress*/ ctx[3]);

	const block = {
		c: function create() {
			div = element("div");
			create_component(postcodelookup.$$.fragment);
			attr_dev(div, "class", div_class_value = /*root*/ ctx[2].container);
			add_location(div, file, 35, 0, 948);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			mount_component(postcodelookup, div, null);
			current = true;
		},
		p: function update(ctx, [dirty]) {
			const postcodelookup_changes = {};
			if (dirty & /*apiKey, apiOverrides*/ 3) postcodelookup_changes.getClient = /*func*/ ctx[7];
			postcodelookup.$set(postcodelookup_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(postcodelookup.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(postcodelookup.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			destroy_component(postcodelookup);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { apiKey } = $$props;
	let { apiOverrides = {} } = $$props;
	let { style = {} } = $$props;

	let { addressTargets = {
		addressLine1: "[data-address-line1]",
		locality: "[data-address-locality]",
		county: "[data-address-county]",
		postcode: "[data-address-postcode]"
	} } = $$props;

	const dispatch = createEventDispatcher();
	setContext("style", style);
	const { classNames: { root = {} } = {} } = style;

	const handleAddress = ({ detail }) => {
		dispatch("address", detail);
		assignValueToTarget(addressTargets.addressLine1, detail.address);
		assignValueToTarget(addressTargets.locality, detail.locality);
		assignValueToTarget(addressTargets.county, detail.region);
		assignValueToTarget(addressTargets.postcode, detail.postcode);
	};

	const writable_props = ["apiKey", "apiOverrides", "style", "addressTargets"];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== "$$") console.warn(`<App> was created with unknown prop '${key}'`);
	});

	let { $$slots = {}, $$scope } = $$props;
	validate_slots("App", $$slots, []);
	const func = () => getClient(apiKey, apiOverrides);

	$$self.$set = $$props => {
		if ("apiKey" in $$props) $$invalidate(0, apiKey = $$props.apiKey);
		if ("apiOverrides" in $$props) $$invalidate(1, apiOverrides = $$props.apiOverrides);
		if ("style" in $$props) $$invalidate(4, style = $$props.style);
		if ("addressTargets" in $$props) $$invalidate(5, addressTargets = $$props.addressTargets);
	};

	$$self.$capture_state = () => ({
		setContext,
		createEventDispatcher,
		getClient,
		assignValueToTarget,
		PostcodeLookup,
		apiKey,
		apiOverrides,
		style,
		addressTargets,
		dispatch,
		root,
		handleAddress
	});

	$$self.$inject_state = $$props => {
		if ("apiKey" in $$props) $$invalidate(0, apiKey = $$props.apiKey);
		if ("apiOverrides" in $$props) $$invalidate(1, apiOverrides = $$props.apiOverrides);
		if ("style" in $$props) $$invalidate(4, style = $$props.style);
		if ("addressTargets" in $$props) $$invalidate(5, addressTargets = $$props.addressTargets);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [
		apiKey,
		apiOverrides,
		root,
		handleAddress,
		style,
		addressTargets,
		dispatch,
		func
	];
}

class App extends SvelteComponentDev {
	constructor(options) {
		super(options);

		init(this, options, instance, create_fragment, safe_not_equal, {
			apiKey: 0,
			apiOverrides: 1,
			style: 4,
			addressTargets: 5
		});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "App",
			options,
			id: create_fragment.name
		});

		const { ctx } = this.$$;
		const props = options.props || {};

		if (/*apiKey*/ ctx[0] === undefined && !("apiKey" in props)) {
			console.warn("<App> was created without expected prop 'apiKey'");
		}
	}

	get apiKey() {
		throw new Error("<App>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set apiKey(value) {
		throw new Error("<App>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get apiOverrides() {
		throw new Error("<App>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set apiOverrides(value) {
		throw new Error("<App>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get style() {
		throw new Error("<App>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set style(value) {
		throw new Error("<App>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get addressTargets() {
		throw new Error("<App>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set addressTargets(value) {
		throw new Error("<App>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default App;